import { Util } from '@libs/utilities/util';
import { IStatsDatasetMetrics, Stats } from '@libs/utilities/stats';

import { IGoogleSearchVolumeValue } from '../../../../constants/research';
import { ISearchVolumeTrendEvaluation } from './search-volume-evaluator.interface';
import { SearchVolumeHelperService } from '../../helpers/search-volume-helper.service';


export class SearchVolumeEvaluatorHelper {

	constructor(
		private searchVolumeHelperService: SearchVolumeHelperService
	) {}


	//** Get current search volume from history data */
	current(history: IGoogleSearchVolumeValue[]): number {

		//0 - get annual search volume
		const annualSvHistoryList: IGoogleSearchVolumeValue[] = this.searchVolumeHelperService.getHistoryList(history, 11);

		//1 - return avg annual search volume
		return Math.round(this.searchVolumeHelperService.getAvgSvHistory(annualSvHistoryList));
	}

	//** Get annual history data */
	history(history: IGoogleSearchVolumeValue[], monthDuration: number): IGoogleSearchVolumeValue[] {
		return this.searchVolumeHelperService.getHistoryList(history, monthDuration);
	}

	//** Get stats on the search volume data */
	statistics(history: IGoogleSearchVolumeValue[]): IStatsDatasetMetrics {

		//0 - map search volume data
		const searchVolumeHistory: number[] = this.searchVolumeHelperService.getHistoryVolume(history);

		//1 - get metrics for the search volume data
		return Stats.Basic.metrics(searchVolumeHistory) as IStatsDatasetMetrics;
	}

	//** Get search volume trends */
	trends(history: IGoogleSearchVolumeValue[]): ISearchVolumeTrendEvaluation {
		return {
			trend12Month: this.searchVolumeHelperService.getTrend(history, 11),
			trend6Month	: this.searchVolumeHelperService.getTrend(history, 6),
			trend3Month	: this.searchVolumeHelperService.getTrend(history, 3),
			trend30Day	: this.searchVolumeHelperService.getTrend(history, 1)
		};
	}

	trendByMonthDuration(history: IGoogleSearchVolumeValue[], monthDuration: number): number {
		if (Util.Basic.isUndefined(monthDuration)) throw new Error(`SearchVolumeEvaluatorHelper => trendByMonthDuration => FATAL ERROR: monthDuration is required`);
		return Util.Number.roundDouble(this.searchVolumeHelperService.getTrend(history, monthDuration));
	}

	normalizedValue(svHistoryData: IGoogleSearchVolumeValue[]): number {

		//0 - get annual search volumes
		const svHistoryList: number[] = this.history(svHistoryData, 12).map((svHistory: IGoogleSearchVolumeValue) => svHistory.volume);

		//1 - get avg, min and max values
		const avgSv: number = this.current(svHistoryData);
		const maxSv: number = Math.max(...svHistoryList);
		const minSv: number = Math.min(...svHistoryList);

		//2 - get normalized value and return it
		const normValue: number = Math.round((avgSv - minSv) / (maxSv - minSv + Math.E ** -5));
		return normValue;
	}
}
